import {
  useVersionUpdatedSubscription,
  VersionListItemFragment,
  VersionListItemFragmentDoc,
} from 'gqlTypes'
import { dataIdFromObject } from 'graphql/apolloClient'

export const useVersionUpdated = () => {
  useVersionUpdatedSubscription({
    onSubscriptionData: ({ client, subscriptionData }) => {
      const { data, error } = subscriptionData

      if (error || !data) {
        return
      }

      const cachedVersion = client.readFragment<VersionListItemFragment>({
        fragment: VersionListItemFragmentDoc,
        fragmentName: 'VersionListItem',
        id: dataIdFromObject(data.versionUpdated)!,
      })

      if (!cachedVersion) {
        return
      }

      client.writeFragment({
        fragment: VersionListItemFragmentDoc,
        fragmentName: 'VersionListItem',
        id: dataIdFromObject(data.versionUpdated)!,
        data: data.versionUpdated,
      })
    },
  })
}
